import ViewPadrao from "../views/ViewPadrao";
import LicencaList from "../views/LicencaList";
import LicencaCad from "../views/LicencaCad";

export default {
  path: "licenca",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "licenca-list",
      component: LicencaList
    },
    {
      path: "novo",
      name: "licenca-formulario",
      component: LicencaCad
    },
    {
      path: "editar/:id",
      name: "licenca-formulario-editar",
      component: LicencaCad
    }
  ]
};
